import styled from 'styled-components';
import Link from 'next/link';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';
export const HotelHeader = styled.h2<{
  fontsize?: number;
}>`
  font-weight: 900;
  font-size: ${(p) => `${p.fontsize}px`};
  font-size: 24px;
  color: ${({ theme }) => `${theme.palette.coral}`};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 30px;
  }
  padding-bottom: 3px;
`;

export const HotelDescription = styled.h4`
  line-height: 1.31;
  padding-top: 3px;
  width: 100%;
  font-size: 14px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    width: 54%;
    font-size: 16px;
  }
`;

export const LinkContainer = styled(Link)<{ $containerPosition: string }>`
  display: flex;
  justify-content: ${(props) => `${props.$containerPosition}`};
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => `${theme.palette.coral}`};
  text-decoration: none;
  padding-top: 16px;
  align-items: center;
  gap: 10px;
  @media (min-width: ${LANDING_BREAKPOINT}) {
    padding: unset;
  }
`;

export const LinkDescContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;
